export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9032.cfa2f2aa.jpg";